import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import {connect} from 'react-redux';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import AgentQueueRow from './AgentQueueRow';
import { bindActionCreators } from 'redux';
import { getServicesList } from '../actions/outgoingService';
import { logData } from '../utils/utils';
//import {getQueuedCalls} from '../actions/getCalls';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class QueuePanel extends Component {
	constructor(props) {
    super(props);
    this.state = {
			open: true
			// columns: [
			// 	{title: 'service', key: 'service', style: {width: 200}},
			// 	{title: 'oldest', key: 'time_in_queue', style: {width: 200}},
			// 	{title: 'noAnswered', key: 'num_unattended_calls', style: {width: 200}},
			// 	{title: 'queued', key: 'num_calls_in_queue', style: {width: 200}},
			// ]
		};
  }
	// componentDidMount = () => {
	// 	this.props.getQueuedCalls().then((res) => {
  //   }, (err) => {
  //     logData(err);
  //   });
	// }

	componentDidMount = () => {
		this.getServiceList();
	}

	getServiceList = () => {
    if(this.props.servicesList.length==0){
      this.props.getServicesList().then(() => {
				this.forceUpdate();
      }, (err) => {
				logData(err);
      });
    }
	}
	
	renderCalls = (queuedCalls) => (
		Object.keys(queuedCalls).map(type => (
			// <div key={type}>
			// 		<div className="queueCallRow" style={{width: '70%'}}>
			// 			<b>{queuedCalls[type][0].service_name}</b>
			// 		</div>
			// 		<div className="queueCallRow text-right" style={{width: '30%'}}>
			// 			<b>{queuedCalls[type].length}</b>
			// 		</div>
			// </div>
			<tr key={type}>
				<td style={{width: '80%'}}>{queuedCalls[type][0].service_name}</td>
				<td style={{width: '20%'}}>{queuedCalls[type].length}</td>
			</tr>
			))
	)

	getFilteredQueuedCalls = (queuedCalls) => {
		let tempQueuedCalls = [];

		queuedCalls.forEach((call) => {
			let isServiceNameExists = this.props.servicesList.some((service) => { 
				return service.name == call.service_name; 
			});
			if(isServiceNameExists) {
				tempQueuedCalls.push(call);
			}
		});

		return tempQueuedCalls;
	}

	render() {
		const { translations, selectedLanguage, queuedCalls } = this.props;
		let filteredQueuedCalls = this.getFilteredQueuedCalls(this.props.queuedCalls);
		const queuedCallsByService = mapValues(groupBy(filteredQueuedCalls, 'service_name'));

		return (
      <div className={`panel${this.props.theme} panel-default${this.props.theme}`}>
        <div className={`panel-heading panel-heading${this.props.theme}`}>
          <h3 className="panel-title">
            <a className="show btn-icon" onClick={ ()=> this.setState({ open: !this.state.open })}>
              <span className="icon icon-funnel icon-right-space"></span>
              <span className="anchor_text">{translations.callsInQueue[selectedLanguage]}</span>
              <span className="icon icon-select-arrows pull-right"></span>
            </a>
          </h3>
        </div>
				<Collapse in={this.state.open}>
					<div>
          <ul className="padding-0 margin-bottom-0">
            {filteredQueuedCalls.length>0 && <div className="table-responsive"> 
	            <table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
	              <thead>
	                <tr>
										<th style={{width: '80%'}}>{translations.service[selectedLanguage]}</th>
	                  <th style={{width: '20%'}}>Calls</th>
	                </tr>
	              </thead>
	              <tbody style={{ maxHeight: '300px', overflow: 'auto' }}>
	                {this.renderCalls(queuedCallsByService)}
	              </tbody>
	            </table>
	          </div>
						}
						{filteredQueuedCalls.length==0 &&
							<div className="panel-body text-center small">
								{translations.noCallsInQueue[selectedLanguage]}
							</div>
						}
          </ul>
					</div>
        </Collapse>
      </div>
	  );
	}
}

function mapStateToProps  (state) {
    return {
				queuedCalls: state.queuedCalls.queuedCalls,
				servicesList: state.servicesList,
				translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
				darkMode: state.common.darkMode,
				theme: state.common.theme,
    };
}

function mapDispatchToProps (dispatch) {
	return bindActionCreators({getServicesList}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QueuePanel);



// WEBPACK FOOTER //
// ./src/agent/queue-panel.js